import ScrollAction from 'lib/scroll-action';


/**
 * Video Scroll Action
 *
 * Extended from general scroll action class. To add functionality to play a
 * video over the course of one screen scroll
 */
export default class GalleryScrollAction extends ScrollAction {

    /**
     * constructor
     *
     * @param  {Element} element
     */
    constructor (element, slowScroll) {
        super(element, {
            hijackMode: true,
            horizontalDistance: element.scrollWidth - element.offsetWidth,
            slowScroll: slowScroll
        });
    }

    animationCallback (animationPercentage) {
        window.requestAnimationFrame(() => {
            this.element.style.transform = "translateX(-" + animationPercentage * this.horizontalDistance + "px)";
        });
    }
}



// WEBPACK FOOTER //
// ./lib/gallery-scroll-action.js